// src/utils/avatarHelpers.ts

/**
 * 🎨 Бьюти-набор эмодзи для аватаров
 */
const BEAUTY_EMOJIS =[
  '💜', '✨', '🌸', '🦋', '🌺', 
  '💎', '🌙', '⭐', '🌟', '💫', 
  '🌿', '🔥', '🌷', '🪷', '🧚'
];

/**
 * Генерирует эмодзи-аватар по telegram_id
 */
export const getEmojiAvatar = (telegramId?: number): string => {
  if (!telegramId) return '💜'; // Fallback по умолчанию
  
  const hash = telegramId % BEAUTY_EMOJIS.length;
  return BEAUTY_EMOJIS[hash];
};

/**
 * Безопасное получение имени пользователя
 * @returns "Имя" или "Привет!" если имя отсутствует/некорректное
 */
export const getSafeUserName = (firstName?: string | null): string => {
  if (!firstName || firstName.trim() === '' || firstName === '.') {
    return ''; // Возвращаем пустую строку - будем использовать просто "Привет!"
  }
  return firstName.trim();
};

/**
 * Генерирует приветствие
 */
export const getGreeting = (firstName?: string | null): string => {
  const safeName = getSafeUserName(firstName);
  return safeName ? `Привет, ${safeName}!` : 'Привет!';
};

/**
 * 🎯 НОРМАЛИЗАЦИЯ ИМЕНИ ПОЛЬЗОВАТЕЛЯ ДЛЯ ОТОБРАЖЕНИЯ
 *
 * Приоритет (строго из БД, игнорируя Telegram initDataUnsafe):
 * 1. first_name + last_name из БД (реальное имя пользователя, поддержка эмодзи 🌸)
 * 2. username из БД (@handle в Telegram)
 * 3. "Гость" если всё пусто
 *
 * Почему игнорируем initDataUnsafe.user:
 * - Пользователь может изменить никнейм в Telegram в любой момент
 * - БД — единственный источник правды для персистентных данных
 * - Поддержка эмодзи и переносов строк обеспечивается браузером автоматически
 *
 * Почему first_name + last_name приоритетнее username:
 * - first_name может содержать эмодзи (например "🌸") — это реальное имя пользователя
 * - username — это @handle, технический идентификатор
 * - Для UI важнее показать реальное имя, даже если это просто эмодзи
 *
 * @param user Объект пользователя из AuthResponse (БД)
 * @returns Отображаемое имя пользователя
 */
export const toDisplayName = (user?: {
  username?: string | null;
  first_name?: string | null;
  last_name?: string | null;
} | null): string => {
  if (!user) {
    return 'Гость';
  }

  // 1. Приоритет: first_name + last_name из БД (поддержка эмодзи)
  const firstName = user.first_name?.trim() || '';
  const lastName = user.last_name?.trim() || '';

  if (firstName || lastName) {
    return [firstName, lastName].filter(Boolean).join(' ');
  }

  // 2. Если нет имени → username (@handle)
  if (user.username && user.username.trim()) {
    return user.username.trim();
  }

  // 3. Если всё пусто → "Гость"
  return 'Гость';
};